import { PassengerAddress, Schedule } from './passenger';

interface ContactPerson {
  personID: number;
  type: number;
  name: string;
  phone: string;
  mobile: string;
  emailAddress: string;
  note: string;
}

interface PersonNote {
  personNoteID?: number;
  createdDateTime?: string;
  createdBy?: string;
  edited?: string;
  editedBy?: string;
  title?: string;
  note?: string;
  state?: number;
  [k: string]: unknown;
}

interface Attribute {
  attributeID: number;
  amount: number;
  attribute: Attribute2;
  personID: unknown;
}

interface Attribute2 {
  attributeID: unknown;
  code?: number;
  description: string;
  carAttribute: boolean;
  driverAttribute: boolean;
  operatorText: string;
  type: unknown;
}

export interface Person {
  personID?: number;
  companyNo?: number;
  dateOfBirth?: string;
  publicIDSequence?: number;
  firstName: string;
  lastName: string;
  note?: string;
  publicID?: string;
  phone?: string;
  mobile?: string;
  email?: string;
  information?: string;
  agreementID?: number;
  state?: PassengerStatus;
  addresses?: PassengerAddress[];
  notes?: PersonNote[];
  schedules?: Schedule[];
  attributes?: Attribute[];
  contactPersons?: ContactPerson[];
}

export enum PassengerStatus {
  Completed = -2,
  Inactive = -1,
  Active = 0,
  AwaitingApproval = 1,
}
